import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { HomeComponent } from "./home/home.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import {
  MatPaginatorModule,
  MatPaginatorIntl,
} from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { CoursesService } from "./services/courses.service";
import { HttpClientModule,HTTP_INTERCEPTORS } from "@angular/common/http";
import { MatStepperModule } from "@angular/material/stepper";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatNativeDateModule } from "@angular/material/core";
import { MatSliderModule } from "@angular/material/slider";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatTreeModule } from "@angular/material/tree";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { AmplifyAuthenticatorModule } from "@aws-amplify/ui-angular";
import { LoadingComponent } from "./loading";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { SAVER, getSaver } from "./saver.provider";
import { PichinchaDesignSystemModule } from "@pichincha/ds-angular";
import { RecordCardListComponent } from "./record-card-list/record-card-list.component";
import { GrabacionComponent } from "./grabacion/grabacion.component";
import { getPaginatorES } from "./services/paginatorEs";
import { RouterModule } from "@angular/router";
import { TokenService } from "./services/token";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { SessionService } from "./services/session.service";
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    RecordCardListComponent,
    LoadingComponent,
    GrabacionComponent,
  ],
  exports: [RecordCardListComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AmplifyAuthenticatorModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatProgressBarModule,
    MatCardModule,
    HttpClientModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatTooltipModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatDialogModule,
    AppRoutingModule,
    MatSelectModule,
    MatCheckboxModule,
    DragDropModule,
    MatRadioModule,
    MatSliderModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatTreeModule,
    ScrollingModule,
    FormsModule,
    MatIconModule,
    RouterModule,
    MatSidenavModule,
    PichinchaDesignSystemModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    CoursesService,
    TokenService,
    SessionService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: SAVER, useFactory: getSaver },
    { provide: MatPaginatorIntl, useValue: getPaginatorES() },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
